import React from 'react';
import { LangContext } from '../../contexts/LangContext';
import './NpCard.css';

export default function NpCard({ item, expensive = false, onAddToCart, cartQty = 0, onQtyChange, onRemove }) {
  const { lang, t } = React.useContext(LangContext);
  const [hovered, setHovered] = React.useState(false);
  const [flash, setFlash]     = React.useState(false);
  const [btnPop, setBtnPop]   = React.useState(false);
  const cardRef               = React.useRef(null);

  const locale   = lang === 'USD' ? 'en-US' : 'pt-BR';
  const currency = lang === 'USD' ? 'USD' : 'BRL';
  const formattedPrice = (item.brlPriceValue ?? 0).toLocaleString(locale, { style: 'currency', currency });

  const imgOffset = item.imageOffsetY ?? (expensive ? '-18px' : '-30px');
  const baseSize  = item.imageSize ? `${item.imageSize}px` : null;
  const imgStyle  = {
    ...(baseSize ? { width: baseSize, height: baseSize } : {}),
    transform: hovered
      ? `translateY(${imgOffset}) scale(1.1)`
      : `translateY(${imgOffset}) scale(1)`,
  };

  const triggerAdd = () => {
    setFlash(true);
    setBtnPop(true);
    setTimeout(() => setFlash(false), 600);
    setTimeout(() => setBtnPop(false), 400);
  };

  const handleCardClick = () => {
    if (cartQty === 0) {
      triggerAdd();
      onAddToCart && onAddToCart(item);
    } else {
      triggerAdd();
      onQtyChange && onQtyChange(item.sku, Math.min(cartQty + 1, 120));
    }
  };

  const baseClass = expensive ? 'expensive-card' : 'cheap-card';
  const flashClass = flash ? ` ${baseClass}--added` : '';

  return (
    <div
      ref={cardRef}
      className={`${baseClass}${flashClass}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleCardClick}
    >
      {item.bonusPercent && <div className="bonus-badge">{item.bonusPercent}</div>}

      {/* Imagem */}
      <div className="image-area">
        <img
          src={item.image}
          alt={`${item.npAmount} NP`}
          className={expensive ? 'np-image-expensive' : 'np-image-cheap'}
          style={imgStyle}
        />
      </div>

      {/* Bloco de texto */}
      <div style={{ transform: `translateY(${item.infoOffsetY ?? '0px'})` }}>
        {/* Linha do valor NP */}
        <div className="np-row" style={{ marginBottom: item.npBottomGap ?? undefined }}>
          <img src="img/arrow-left.png"  alt="" className={expensive ? 'np-arrow-expensive' : 'np-arrow-cheap'} />
          <span className={expensive ? 'np-value-expensive' : 'np-value-cheap'}>{item.npAmount}</span>
          <img src="img/icons/NPs.svg"   alt="NP" className={expensive ? 'np-icon-expensive' : 'np-icon-cheap'} />
          <img src="img/arrow-right.png" alt="" className={expensive ? 'np-arrow-expensive' : 'np-arrow-cheap'} />
        </div>

        {/* Breakdown opcional */}
        {item.baseNp && (
          <div className="breakdown">{item.baseNp} + {item.bonusNp} NP</div>
        )}

        {/* Preço + botão */}
        <div className={expensive ? 'price-area-expensive' : 'price-area'}>
          <span className="brl-price">{formattedPrice}</span>
          {cartQty > 0 ? (
            <div className={`${expensive ? 'add-to-cart-btn-expensive' : 'add-to-cart-btn-cheap'} cart-qty-controls`} onClick={e => e.stopPropagation()}>
              <button
                className="cart-ctrl-btn"
                onClick={() => cartQty === 1 ? onRemove(item.sku) : onQtyChange(item.sku, cartQty - 1)}
              >
                {cartQty === 1
                  ? <img src="img/icons/thrash-black.svg" alt="remover" className="cart-ctrl-trash" />
                  : '−'}
              </button>
              <span className="cart-ctrl-qty">{cartQty}</span>
              <button
                className="cart-ctrl-btn"
                onClick={() => onQtyChange(item.sku, Math.min(cartQty + 1, 120))}
              >+</button>
            </div>
          ) : (
            <button
              className={`${expensive ? 'add-to-cart-btn-expensive' : 'add-to-cart-btn-cheap'}${btnPop ? (expensive ? ' add-to-cart-btn-expensive--pop' : ' add-to-cart-btn-cheap--pop') : ''}`}
              onClick={e => { e.stopPropagation(); triggerAdd(); onAddToCart && onAddToCart(item); }}
            >
              {t.component.packCard.addToCart}
              <img src="img/cart.png" alt="carrinho" className="cart-icon" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
